// import Color from 'color'

export const white = '#ffffff'
export const black = '#000000'
export const blue = '#009ee3'
export const beige = '#f3f1ee'
export const grayLight = '#E3E3E3'
export const gray = '#979797'
export const grayDark = '#454543'
export const red = '#eb4322'
